import styled, { css } from "styled-components";
import { Form, Radio, Row, DatePicker, Button } from "antd";
import {
  GhostButtonComponent,
  UnderlineLink,
  PillButton,
  DisplayFlex,
  ContentContainer,
  StepFlexRow
} from "../../../../../../../../CommonComponents/commonStyles";

const styles = css`
  font-family: HelveticaNeue-Medium;
  font-size: 16px;
  color: #006778;
`;

const fontCommonStyle = css`
  font-family: HelveticaNeue;
  font-size: 16px;
  color: #505050;
`;

const cursorPointer = css`
  cursor: pointer;
`;

export const Err = styled.div`
  margin-top: -20px;
  ${fontCommonStyle}
  color: #f74c52;
  line-height: 1.25;
  letter-spacing: 0.6px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const PagesHeadingWrapper = styled.div`
  font-family: BerkeleyStd-Book;
  font-size: 42px;
  line-height: 1.14;
  color: #022737;
  margin-bottom: ${props => props.marginBottom};

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 36px;
    width: 316px;
    height: 84px;
    line-height: 1.2;
    color: #022737;
  }
`;

export const ContentContainerSpace = styled(ContentContainer)`
  padding: 2.75rem 9% 0 9%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 2.75rem 6.4% 0 6.1%;
  }
`;
export const SubHeading = styled.div`
  ${fontCommonStyle}
  line-height: 1.5;
  max-width: 980px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const TabsContent = styled.div`
  line-height: 40px;
  padding: 0 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 0 15px;
  }
`;

export const TooltipTextwrap = styled.span`
  font-family: HelveticaNeue;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.5px;
  color: #ffffff;
  text-align: center;
  display: flex;
  width: 170px;
  padding: 5px 5px;
`;

export const StepFlexRowMargin = styled(StepFlexRow)`
  margin-top: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 30px;

    .ant-col-lg-4 {
      margin-bottom: 20px;
    }
  }
`;

export const FormContainer = styled(Form)`
  &&& {
    margin-top: ${props => props.theme.spacing.margins.YBetween};
    .ant-form-item-control .ant-calendar-picker,
    .ant-input-number {
      width: 100%;
    }
    .ant-form-item-control {
      line-height: 0;
    }
  }
`;

export const RadioButtonWrapper = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
`;

export const LabelWrapper = styled.div`
  ${fontCommonStyle}
  font-family: HelveticaNeue-Bold;
  line-height: 1.5;
  margin-bottom: 4px;
  margin-top: 34px;
  content: none;
`;

export const PhoneLabelWrap = styled(LabelWrapper)`
  margin-top: 10px;
  margin-bottom: 4px;
`;
export const EmailLabelWrap = styled(LabelWrapper)`
  margin-top: 34px;
  margin-bottom: 20px;
`;

export const LabelWrapperDelivery = styled(PhoneLabelWrap)`
  margin-top: 34px;
`;

export const MainWrapper = styled.div`
  .ant-form-item-label {
    label::after {
      content: none;
    }
  }
`;

export const RadioWrapper = styled.div`
  .ant-radio-inner {
    border-color: #b6bdbd;
  }
  .ant-radio-inner::after {
    background-color: #006778;
  }
`;
export const PrimaryElement = styled.span`
  display: inline-block;
  margin-top: 2px;
`;
export const MailContentWrapper = styled.div`
  .ant-radio-wrapper {
    font-size: 16px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
    }
  }
  ${fontCommonStyle}
  line-height: 1.5;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .ant-radio-inner {
    top: 3px;
    border-color: #b6bdbd;
  }
  .ant-radio-inner::after {
    background-color: #006778;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
  .ant-radio-wrapper {
    display: flex;
    align-items: flex-start;
    font-weight: normal;
    margin-right: 14px;
  }
`;

export const MailContentWrapperfirst = styled(MailContentWrapper)`
  .ant-radio-wrapper {
    display: flex;
    align-items: flex-start;
  }
`;

export const Underlinelink = styled(UnderlineLink)`
  letter-spacing: 0px;
  ${styles}
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: block;
    font-size: 14px;
    margin-left: 26px;
  }
`;

export const PillButtonAdd = styled(PillButton)`
  ${styles}
  font-size: 14px;
  background-color: #f5f5f5;
  margin: 16px 20px 0px 0;
  &:hover,
  &:focus {
    color: #006778;
    background: #f5f5f5;
    border-color: #d9d9d9;
  }
`;

export const PillButtonAddressWrap = styled.div`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 16px;
  }
`;

const buttonCommon = css`
  font-family: HelveticaNeue-CondensedBlack !important;
  font-size: 18px !important;
  line-height: 1.67 !important;
  letter-spacing: 1.1px !important;
  width: 150px !important;
  height: 50px !important;
  ${cursorPointer};
`;

export const GhostButton = styled(GhostButtonComponent)`
  ${buttonCommon}
  color: #006778;
  margin: 26px 30px -5px 0;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 15px 15px 0;
    flex: 1;
  }
`;

export const GhostButtonReset = styled(GhostButton)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 0 10px 0;
    flex: 1;
  }
`;

export const PrimaryButtonComponent = styled(Button)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  background-color: ${props => props.theme.colors.primaryColor};
  font-size: 16px;
  color: ${props => props.theme.colors.white};
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: 0.5px;
  border-radius: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  height: 50px;
  opacity: ${props => (props.opacity ? props.opacity : "1")};
  border: ${props => props.borderEffect};
  width: ${props => (props.width ? props.width : "100%")};
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.primaryColor};
    color: ${props => props.theme.colors.white};
    border: ${props => props.borderHover};
    border-color: ${props => props.theme.colors.primaryColor};
  }
  @media only screen and (max-width: 990px) {
    width: 100%;
  }
`;

export const PrimaryButtonComponentNext = styled(PrimaryButtonComponent)`
  ${buttonCommon}
  text-align: center;
  margin-top: 26px;
  border-radius: 0;
  border: none;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100% !important;
    margin-top: 0;
  }
`;

export const PrimaryButtonComponentDisabled = styled(
  PrimaryButtonComponentNext
)`
  background-color: rgba(0, 103, 120, 0.3) !important;
  color: #ffffff !important;
`;

export const DisplayFlexSpace = styled(DisplayFlex)`
  justify-content: space-between;
`;

export const DisplayFlexSpaceMobile = styled(DisplayFlexSpace)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    padding-top: 16px;
  }
`;

export const SelectTabsWrapper = styled.div`
  .ant-tabs-bar {
    margin: 0;
    justify-content: space-between;
    flex-direction: row-reverse;
    align-items: center;
    border-bottom: 1px solid #d4d4d4;

    .ant-tabs-nav {
      /* border-left: 1px solid #bfbfbf;
      border-right: 1px solid #bfbfbf; */
    }

    .ant-tabs-nav-container {
      height: 55px !important;
    }
  }

  .ant-tabs-tab:hover {
    color: unset;
  }

  .ant-tabs.ant-tabs-card {
    .ant-tabs-card-bar {
      .ant-tabs-tab {
        margin-right: 0;
        border: none;
        padding-left: 0;
        padding-right: 0;
        border-top: 4px solid rgba(0, 103, 120, 0.1);
        height: 56px;
        border-bottom: 1px solid #d4d4d4;
        background-color:#f4f3f3!important;
      }

      .ant-tabs-tab.ant-tabs-tab-active {
        border-left: 1px solid #d4d4d4;
        border-right: 1px solid #d4d4d4;
        color: #006778;
        border-top: none;
        border-top: 4px solid #006778 !important;
        height: 56px;
        border-bottom: none;
        background-color: #ffffff !important;
      }
    }
  }

  .ant-tabs-tab {
    font-family: HelveticaNeue-Bold;
    font-size: 16px;
    letter-spacing: 0.6px;
    text-align: center;
    background-color: #d4d4d4 !important;
    border-radius: 0 !important;
    border-right: 1px solid #d4d4d4 !important;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
      letter-spacing: 0.5px;
    }
  }
`;

export const SelectOptionGenderWrapper = styled.div`
  .ant-select-selection {
    .ant-select-arrow {
      i {
        display: block;
      }
    }
  }

  .ant-select-arrow {
    color: #606060;
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #d4d4d4;
    background: #f5f5f5;
  }
`;

export const SelectOptionMainWrapper = styled.div`
  .ant-select-dropdown {
    border: 1px solid #d4d4d4;
    border-top: none;
    border-radius: 0;
    box-shadow: -7px 9px 15px 0 rgba(223, 223, 223, 0.5);
    li {
      border: none;
      background-color: #ffffff;
      padding: 5px 20px;
    }
    li:hover {
      color: #167f91;
      background-color: #e6f7ff;
    }
  }

  .ant-select-dropdown:after {
    bottom: 0;
  }
`;

export const SelectOptionWrapper = styled.div`
  font-family: HelveticaNeue;
  color: #606060;
  font-size: 14px;
  line-height: 2.15;
  padding-top: 5px !important;
  font-weight: normal;
`;

const titleCommmon = css`
  ${fontCommonStyle}
  line-height: 1.25;
  letter-spacing: 0.6px;
  font-weight: normal;
`;
export const TitleWrapper = styled.div`
  ${titleCommmon}
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const TitleWrapperTitle = styled(TitleWrapper)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 0;
  }
`;

export const ExtraContentWrapper = styled.div`
  ${titleCommmon}
  padding-top: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: none;
    margin-bottom: 150px;
  }
`;

export const MiddleName = styled.div`
  color: #505050;
  font-size: 16px;
`;

export const InputWrapper = styled.div`
  input,
  .ant-select-selection--single {
    height: 40px !important;
  }

  .ant-select-arrow-icon {
    display: none;
  }

  input::placeholder {
    color: #d4d4d4;
  }

  .ant-select-selection {
    border-radius: 0;
    display: flex;
    align-items: center;
    border: 1px solid #d4d4d4;
  }

  .ant-input {
    border-radius: 0;
    color: #505050;
    font-size: 16px;
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
    }
  }
  .ant-input.has-error:hover {
    border: 1px solid #d4d4d4 !important;
  }

  .ant-calendar-picker-input {
    margin-top: 0 !important;
  }
`;

export const SelectWrapperGraded = styled(InputWrapper)`
  .ant-select-selection {
    background: #f2f2f2 !important;
    border: 1px solid #d4d4d4;
  }

  .ant-select-arrow-icon {
    display: block;
  }

  .ant-input {
    border: 1px solid #d4d4d4;
    font-size: 16px;
  }

  .ant-select-selection-selected-value {
    color: #505050;
    font-size: 16px;
  }
`;

export const InputWrapperGraded = styled(InputWrapper)`
  input {
    padding: 0 20px;
  }

  input::placeholder {
    color: #d4d4d4;
  }

  .ant-select-selection-selected-value {
    color: #505050;
    font-size: 16px;
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
    }
  }

  .ant-select-selection__rendered {
    margin: 0;
  }
`;

export const SecurityNumWrap = styled.div`
  input {
    height: 45px;
  }
  .ant-input {
    border-radius: 0;
    font-size: 16px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
    }
  }

  .ant-input-suffix {
    display: none;
  }
`;

export const SpanWrap = styled.span`
  white-space: pre-wrap;
  span {
    display: inline-block;
    vertical-align: top;
  }
`;

export const TitleWrapperPrimary = styled.div`
  margin-top: ${props =>
    props.marginTop === undefined ? "30px" : props.marginTop};
  height: 70px;
  margin-left: 6px;
  ${titleCommmon};
  display: flex;
  align-items: center;
  .ant-radio-wrapper {
    margin-right: 20px;
  }
  .ant-radio-wrapper,
  a {
    margin-top: 0px;
    font-size: 16px;
    font-weight: normal;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin-top: 0;
      font-size: 14px;
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 0;
    height: 14px;
    margin-bottom: 24px;
    margin-top: 40px;
  }

  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    margin-left: 0;
    height: 14px;
    margin-bottom: 24px;
    margin-top: 16px;
  }
`;

export const TitleWrapperPrimaryAdress = styled(TitleWrapperPrimary)`
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    margin-left: 0;
    height: 14px;
    margin-bottom: 24px;
    margin-top: 60px;
  }
`;

export const NoResultsWrap = styled.div`
  margin-left: 11px;
`;

export const InputWrapperDrop = styled.div`
  .ant-select-selection--single {
    height: 40px !important;
  }
  .ant-select-selection-selected-value,
  .ant-select-search__field {
    line-height: 38px;
    vertical-align: middle;
    font-size: 16px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
      display: flex !important;
      align-items: center;
      height: 100%;
    }
    div {
      font-size: 16px;
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: 14px;
      }
    }
  }

  .ant-select-selection__placeholder {
    font-size: 16px;
    color: #d4d4d4;
    padding: 0 9px;
  }
  .ant-select-selection {
    border-radius: 0;
    border: 1px solid #d4d4d4;
  }

  .ant-select-selection {
    box-shadow: none;
  }

  .ant-select-selection__rendered {
    height: 100%;
    padding: 0 9px;
  }

  .ant-select-arrow {
    color: #606060;
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #d4d4d4;
    background: #f5f5f5;
  }
`;

export const WebTitle = styled.div`
  font-family: BerkeleyStd-Book;
  font-size: 24px;
  line-height: 1.17;
  color: #022737;
  padding: 0 20px 0 18px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 0 0 5px 5px;
  }
  @media only screen and (min-width: 320px) and (max-width: 321px) {
    font-size: 21px;
    padding: 0 0 5px 0px;
  }
`;

export const NoChange = styled.div`
  ${fontCommonStyle};
  line-height: 1.13;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 7px;
  }
`;

export const NoChangeSpace = styled(NoChange)`
  margin-bottom: 45px;
  width: 172px;
  display: flex;
  justify-content: space-between;
  margin-top: -3.25rem;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
    margin-left: 0;
  }
`;

export const WebAccessHeaderWrapper = styled.div`
  height: 58px;
  display: flex;
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 78px;
  }
`;

export const Align = styled.span`
  display: flex;
  align-items: center;
`;

export const AlignContent = styled.span`
  display: flex;
  align-items: center;
  .ant-checkbox-wrapper {
    margin-bottom: 9px !important;
  }
`;

export const RadioWrappered = styled.div`
  &&& {
    .ant-radio {
      margin-top: -4px;
    }
  }
`;
export const DisplayFlexAlign = styled(DisplayFlex)`
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    margin-right: 15px;
    align-items: initial;
  }
`;

export const DisplayFlexSpaceWidth = styled(DisplayFlexSpace)`
  width: 100%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    align-items: center;
  }
`;

export const WebAccessInfoWrapper = styled.div`
  .ant-collapse-item {
    background: #ffffff;
    border-bottom: none;
  }

  .ant-collapse-content {
    border-radius: 0 !important;
    .ant-collapse-content-box {
      padding: 0 32px 6px;
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding: 0 20px 6px;
      }
    }
  }

  .ant-collapse-content {
    border-top: none;
  }

  .ant-collapse {
    border-radius: 0;
    border-bottom: 1px solid #d9d9d9;
  }

  margin-bottom: 50px;
  margin-top: 16px;
`;

export const ExpandWrap = styled.div`
  margin: 5px 14px 0 0;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 4px 0 0;
  }
`;

export const AdvisoryFormWrapper = styled.div`
  .ant-form {
    margin-top: 20px !important;
  }
`;

export const RowWrapper = styled(Row)`
  /* margin-top: 6px; */
`;

export const FlexWrap = styled.div`
  display: flex;
  align-items: baseline;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: block;
  }
`;

export const EmailWrapper = styled.div`
  .ant-checkbox-wrapper {
    margin-top: 8px;
    .ant-checkbox-inner {
      width: 15px;
      height: 15px;
    }
    .ant-checkbox-checked {
      .ant-checkbox-inner {
        background-color: #006778;
        border-color: #006778;
      }
    }
  }
`;
export const EmailTitleWrapper = styled(TitleWrapper)`
  margin-right: 20px;
`;

export const CheckWrap = styled.span`
  ${fontCommonStyle}
  font-size: 12px;
  line-height: 1.5;
  font-weight: normal;
`;

export const IconWrap = styled.div`
  float: right;
  ${cursorPointer};
  margin-right: -20px;
  i {
    font-size: 20px;
    color: #1d1d1b;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-right: 0;
  }
`;

export const HeightDiv = styled.div`
  height: ${props => props.height}
  border-bottom: ${props => props.borderBottom}
  margin-top: ${props => props.marginTop}
`;

export const HeightDivBottom = styled.div`
  height: 12%;
  margin-top: 30px;
  display: flex;
  justify-content: center;
`;

export const InfoContentWrapper = styled.div`
  background: #ffffff;
  width: 79%;
  margin: auto;
  padding: 30px 50px 30px 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 87.5%;
  }
`;

export const InfoWrapper = styled.div`
  position: fixed;
  left: 0;
  z-index: 10000;
  background-color: rgba(0,0,0,0.5);
  width: 100%;
  height: 100%;
  top: 0;
  padding-top: 100px;
`;

export const PopHeader = styled.div`
  font-family: BerkeleyStd-Bold;
  font-size: 24px;
  line-height: 1.17;
  color: #022737;
  text-align: center;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15% @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 20px;
  }
`;

export const QASectionWrapper = styled.div`
  margin: 15px 0 9px 0;
  margin-bottom: 24px;
`;

export const QASectionWrapperLast = styled(QASectionWrapper)`
  margin-bottom: 9px;
`;
export const QuestionWrap = styled.div`
  ${fontCommonStyle};
  font-family: HelveticaNeue-Bold;
  line-height: 1.5;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const QASection = styled.div`
border-top: 2px solid #bfbfbf;
  border-bottom: 2px solid #bfbfbf;
  height: 240px;
  overflow: scroll;
`;

export const AnswerWrap = styled.div`
  ${fontCommonStyle};
  line-height: 1.5;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const PrimaryButtonOkay = styled(PrimaryButtonComponent)`
  width: 200px !important;
  border-radius: 0;
  font-family: HelveticaNeue-CondensedBold;
  font-size: 16px;
  ${cursorPointer}
  border: none;
  z-index: 10003;
`;

export const DisplayFlexOkay = styled(DisplayFlex)`
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

export const TitleMarginTop = styled.div`
  margin-top: 16px;
`;

export const TitleMarginBottom = styled.div`
  margin-bottom: 16px;
`;

export const DeliveryMarginBottom = styled.div`
  margin-bottom: 20px;
`;

export const AddressWrap = styled.div`
  margin-bottom: -10px;
`;

export const AdvisorMargin = styled.div`
  margin-bottom: 50px;
`;

export const SelectdropwownStyles = styled.div`
  .ant-select-dropdown {
    top: 40px !important;
    width: 100% !important;
  }
`;
export const InputMargin = styled.div`
  .ant-form-item {
    margin-bottom: 40px;
  }
`;
export const WrapLabel = styled.div`
  &&& {
    .ant-form-item-label {
      margin-bottom: 10px;
    }
  }
  &&& {
    .ant-form-item-label > label::after {
      margin: 0;
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    &&& {
      .ant-form-item-label {
        padding: 0;
      }
    }
  }
`;

export const WebAccessInfoMargin = styled.div`
  .ant-form-item {
    margin-bottom: ${props => (props ? props.marginBottom : "20px")};
  }
`;

export const AdressButtonMargin = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;
export const DatePickerWrapper = styled.div`
  &&& {
    .ant-calendar {
      background: red;
      width: 327px;
    }
  }
`;

export const TabWrap = styled.div`
  line-height: 36px;
`;

export const CalenderDisabling = styled(DatePicker)`
  .ant-input-disabled + i.anticon {
    cursor: not-allowed;
  }
`;

export const ExtraContentMobile = styled.div`
  font-family: HelveticaNeue;
  font-size: 14px;
  line-height: 1.25;
  letter-spacing: 0.6px;
  color: #505050;
  margin-bottom: 20px;
`;
